'use client';

import { ReactNode, useMemo, useState } from "react";
import { ICategoryOrTag, IPost } from "../../models/ICategory";
import { useInfiniteQuery } from "@tanstack/react-query";
import { apiService } from "../../services/ApiService";
import Button, { ButtonTheme } from "../components/Button";
import { ILocalizedParams } from "../../models/ICommon";
import ArticleBrief from '../components/ArticleBrief';


const locales = {
  ar: {
    button: 'المزيد',
    loading: 'تحميل'
  },
  en: {
    button: 'More',
    loading: 'Loading'
  },
}

interface Props {
  category: ICategoryOrTag;
  locale: string;
  device?: string;
}

export default function CategoryPosts({ category, locale, device }: ILocalizedParams<Props>) {
  const {
    data,
    isFetching,
    isLoading,
    fetchNextPage,
    hasNextPage
  } = useInfiniteQuery({
    retry: false,
    initialData: () => {
      return {
        pageParams: [undefined, 1],
        pages: [category.posts]
      }
    },
    enabled: false,
    queryKey: [locale, category.uniqueCode, 'category-posts'],
    queryFn: async ({ pageParam = 1 }) => {
      const result = await apiService.getCategoryOrTag('category', { id: category.uniqueCode || category.slug, type: 'slug' }, { page: pageParam as number, pageSize: category.posts.pageSize }).then(x => x.posts);
      return result;
    },
    getNextPageParam: (lastPage, allPages, lastPageParam, allPagesParam) => {
      if (!lastPage) return 1;
      return lastPage.page < lastPage.totalPages ? lastPage.page + 1 : undefined;
    },
    initialPageParam: category.posts.page ? category.posts.page + 1 : 1
  });

  const totalData = useMemo(
    () => (data?.pages ? data.pages.map(item => item.data).flat(Infinity) : []),
    [data]
  ) as IPost[];

  
  return (
    <div className="flex flex-col pt-[40px] tablet:py-[40px]">
      <div className='category-posts'>
        {totalData.map((p,i) => {
          return <ArticleBrief h2 device={device} hideCategory hideMeta data={{ eager: i <= 2, post: p, category: { title: category.title, slug: category.slug, uniqueCode: category.uniqueCode } }} locale={locale} />
        })}
      </div>
      {isLoading || isFetching ?
        <div className='w-full grid place-items-center string-18 my-[60px]'>{locales[locale].loading}...</div> :
        (
          hasNextPage ?
          <div className='w-full desktop:w-[520px] mt-[60px] h-[60px] flex justify-center items-center mx-auto'>
            <Button locale={locale} title={locales[locale].button} theme={ButtonTheme.primary} className='h-full' showIcon onClick={() => fetchNextPage()} />
              
              </div> :
            null
        )
      }
    </div>
  )



}